<script>
	  import { createEventDispatcher } from 'svelte';

    export let type = 'button';
    export let primary = false;
    export let raised = false;
    let className = "";
    let styleDef = "";

    export {className as class};
    export {styleDef as style};

	  const dispatch = createEventDispatcher();
	  const submit = () => dispatch('submit');
</script>


 <button on:click={submit} 
        class:bg-main={primary}
        class:border={raised}
        class:border-gray-300-md={raised}
        class:text-white={primary} 
        class="hover:opacity-75 font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline {className}" 
        type="{type}"
        style="{styleDef}">        
          <slot></slot>
</button>

          <!-- class:shadow-md={raised} -->
